'use client';

import { Icons } from '@/components/icons';
import { MainNavigation } from '@/components/navigation/main-navigation';
import { MobileNavigation } from '@/components/navigation/mobile-navigation';
import { useLocalePath } from '@/shared/hooks';
import Link from 'next/link';
import { useEffect, useState, type FC } from 'react';

export const SiteHeader: FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const { to } = useLocalePath();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full h-16 transition-all duration-300 ${
        scrolled ? 'bg-[#0A0A0A] backdrop-blur-[12px]' : 'bg-[#0A0A0A]'
      }`}
    >
      <div className="flex h-full items-center justify-between px-6 md:container">
        <Link href={to('/')} className="flex items-center">
          <Icons.mark className="size-8 text-white" />
        </Link>
        <div className="hidden md:flex items-center gap-8">
          <MainNavigation />
        </div>
        <div className="flex items-center gap-4">
          <Link
            href={to('/contact')}
            className="hidden md:inline text-sm font-medium text-[#F24E1E] hover:text-white transition-colors duration-150"
          >
            Start a project →
          </Link>
          <div className="md:hidden">
            <MobileNavigation />
          </div>
        </div>
      </div>
    </header>
  );
};
